<script>
export default {
  props: {
    testimonial: {
      type: Object,
      default() {
        return {
          info: "",
          name: "",
          color: "",
        };
      },
    },
  },
};
</script>

<template>
    <div
    :style="{ border: `4px solid ${testimonial.colorClass}` }"
    :class="[$style.testimonialCard, testimonial.borderClass]"
    class="d-inline-block w-100"
  >
    <p
      :class="[testimonial.textClass]"
      class="text-center"
      :style="{ color: `${testimonial.colorClass}` }"
    >
      {{ testimonial.info }}
    </p>
    <div class="w-100 d-inline-block text-center" :class="$style.name">
      {{ testimonial.name }}
    </div>

    <svg
      :class="[$style.tCorner, $style[testimonial.borderClass]]"
      width="48px"
      height="22px"
      viewBox="0 0 48 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Path 2</title>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        :fill="testimonial.colorClass"
        fill-rule="evenodd"
      >
        <g id="Path-2" transform="translate(1.000000, 0.000000)">
          <path
            d="M0.504501343,2 C0.557334343,8.354591 0.65509,12.519001 1.806771,14.493231 C3.841953,17.981972 8.106108,19.887659 12.116926,19.887659 C16.080334,19.887659 20.904895,16.948658 27.983944,12.803493 C31.269256,10.879765 37.184371,7.278601 45.72929,2"
            :stroke="testimonial.colorClass"
            stroke-width="3"
            fill="#fff"
            fill-rule="nonzero"
          ></path>
          <polygon
            id="Rectangle"
            fill="#fff"
            points="1.99632263 1.00335693 44.937439 0.727493286 42.8999018 2 1.99632263 2"
          ></polygon>
        </g>
      </g>
    </svg>

    <div
      :class="[$style.cornerEdge, $style[testimonial.borderClass]]"
      :style="{ border: `4px solid ${testimonial.colorClass}` }"
    />
  </div>
</template>

<style lang="scss" module>
@import "@/design/index.scss";
.testimonialCard {
  position: relative;
  background-color: $white;
  border-radius: 14px 14px 14px 2px;
  border-width: 3px;
  border-style: solid;
  // min-height: 260px;
  height: calc(100% - 30px);
  padding: 50px 55px;
  margin-bottom: 50px;
  p {
    font-size: 24px;
    font-family: $family-bold;
    margin-bottom: 20px;
    line-height: 32px;
  }
  .name {
    font-size: 20px;
  }
  .cornerEdge{
    position: absolute;
    bottom: 20px;
    left: -67px;
    border-width: 3px;
    border-style: solid;
    width: 170px;
    height: 100px;
    border-radius: 18px;
    transform: rotate(65deg);
    display: none;
  }
  .tCorner{
    position: absolute;
    bottom: -21px;
    left: -3px;
    &.border-color-orange{
      path{
        stroke: $orange-color;
      }
    }
    &.border-color-pink{
      path{
        stroke: $pink-color;
      }
    }
    &.border-color-green{
      path{
        stroke: $green-color;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .testimonialCard{
    padding: 45px 35px; 
    // min-height: 430px;
    margin-left: 30px;
    p {
    }
    .name {
    }
  }
}
@media only screen and (max-width: 500px) {
  .testimonialCard {
    padding: 50px 30px;
    // min-height: 410px;
    p{
      font-size: 20px;
    }
  }
}
</style>